import  List  from './list/Settlement-period';

export default { List }